import { addListener, hideElements, showElements } from "@grindex-common/helpers/domManipulation";

import { ProductsCompareItem } from "./ProductsCompareItem.class";

import { $elementChildren } from "@grindex-common/helpers/elements";

const SELECTOR_COMPARE_BUTTON = "[xyl-element='compare-label']";
const SELECTOR_COMPARE_CHECKBOXES = "div.compare .styledCheckbox";
const ELEMENT_COMPARE_CONTAINER = "compare-container";

export default class ProductsComparer {
	constructor($module) {
		this.$module = $module;
		this.compareItems = [];
	}

	bindEvents() {
		addListener(document.querySelectorAll(SELECTOR_COMPARE_BUTTON), "click", this.compareProducts.bind(this));
		addListener(document.querySelectorAll(SELECTOR_COMPARE_CHECKBOXES), "click", this.compareEvent.bind(this));

		$elementChildren(this.$module, ELEMENT_COMPARE_CONTAINER).forEach(($comparer) => {
			this.compareItems.push(new ProductsCompareItem($comparer));
		});
	}

	compareEvent(event) {
		const $target = event.target.querySelector("input");
		if ($target) {
			this.compareValueChanged({
				currentTarget: $target,
			});
		}
	}

	compareProducts(e) {
		e.preventDefault();

		if (!e.currentTarget.classList.contains("button")) {
			return;
		}

		const compareURL = this.getCompareUrl();

		window.location.href = compareURL;
	}

	getCompareUrl() {
		let compareURL = window.config.search.compareUrl + "?";

		const selectedBoxes = this.compareItems.filter((item) => {
			return item.isSelected();
		});

		for (let i = 0; i < selectedBoxes.length; i += 1) {
			compareURL += "productids=" + selectedBoxes[i].id;
			if (i !== selectedBoxes.length - 1) {
				compareURL += "&";
			}
		}

		return compareURL;
	}

	getBoxesByStatus(items, selected) {
		return items.filter((item) => {
			return selected ? item.isSelected() : !item.isSelected();
		});
	}

	enableDisableCompareButtons(selectedCount) {
		if (selectedCount < 2) {
			hideElements(SELECTOR_COMPARE_BUTTON, this.$module);
		} else {
			showElements(SELECTOR_COMPARE_BUTTON, this.$module);
		}

		this.initCheckboxes();
	}

	compareValueChanged(e) {
		const $target = e.currentTarget;
		const compareItem = this.compareItems.filter((item) => {
			return item.id === $target.value;
		})[0];

		if (!compareItem.isSelected()) {
			compareItem.unSelect();
		}

		this.updateCompareStatus();
	}

	updateCompareStatus() {
		const selectedCount = this.getBoxesByStatus(this.compareItems, true).length;
		const notSelectedBoxes = this.getBoxesByStatus(this.compareItems, false);

		if (selectedCount > 1) {
			this.addButtonClassToSelectedCompareItems();
		} else {
			this.removeButtonClassFromCompareItems();
		}

		notSelectedBoxes.forEach((checkbox) => {
			if (selectedCount < 3) {
				checkbox.show();
				checkbox.enable();
			} else {
				checkbox.hide();
				checkbox.disable();
			}
		});
	}

	removeButtonClassFromCompareItems() {
		this.compareItems.forEach((compareItem) => {
			compareItem.$label.classList.remove("button");
		});
	}

	addButtonClassToSelectedCompareItems() {
		this.compareItems
			.filter((compareItem) => {
				return compareItem.isSelected();
			})
			.map((checkedItem) => {
				checkedItem.$label.classList.add("button");
			});
	}
}
